import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import ApartmentConfirmationForm from '../../../Forms/ApartmentConfirmationForm'
import { getApartmentConfirmationInitialValues } from '../../../Forms/values/apartmentInitialValues'
import { BeforeLoginStepProps } from '../../BeforeLoginStepper'

const ConfirmationStep = ({
  currentStep,
  apartment,
  classes,
  confirmApartment,
  doStepBack,
  beforeLogin
}: BeforeLoginStepProps) => (
  <Fragment>
    {apartment?.information && currentStep >= 9 && currentStep <= 11 && (
      <Grid container direction='row' justify='space-evenly'>
        <Grid item sm={12} md={12}>
          <Paper className={classes.formPaper}>
            <ApartmentConfirmationForm
              initialValues={{
                ...(apartment.confirmation
                  ? getApartmentConfirmationInitialValues(
                      apartment.confirmation
                    )
                  : { showingType: 'openHouse', announcementType: 'regular' }),
                ...apartment?.credentials
              }}
              vuokraoviCollateral={(apartment.confirmation as any)?.vuokraoviCollateral}
              updateApartmentConfirmation={confirmApartment}
              isDisabled={false}
              isBeforeLogin
              createdAt={apartment.createdAt}
              currentStep={currentStep}
              doStepBack={doStepBack}
              classes={classes}
              beforeLogin={beforeLogin}
            />
          </Paper>
        </Grid>
      </Grid>
    )}
  </Fragment>
)

export default ConfirmationStep
